module.exports = __webpack_public_path__ + "static/media/save.5aad5037.svg";